import { IsArray, IsOptional, IsUUID } from 'class-validator';

export class UpdateUserLobbyTeamsDto {
	@IsOptional()
	@IsArray()
	@IsUUID('4', { each: true })
	teams_ids?: string[];
}
